import React from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Table, Params, Actions, Menu } from 'nallian-table-builder-ui';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import { PageContent, PageTitle, Button, Link } from 'nallian-shared-ui/lib/components';
import { ACTIONS, INFINITE_SCROLL, IDENTIFICATIONCODETYPES_RESOURCE } from '../constants';
import NewType from './NewType';
import EditType from './EditType';
import apiRoutes from '../../../app/api/routes';

const CREATE_RIGHT = 'identification-code-types/create';
const UPDATE_RIGHT = 'identification-code-types/update';
const REMOVE_RIGHT = 'identification-code-types/delete';

const MANAGE_RIGHTS = [UPDATE_RIGHT, REMOVE_RIGHT];

const IdentificationCodeTypesOverview = () => {
  const { t } = useTranslation();
  const { id, action } = useParams();

  return (
    <>
      <PageTitle>{t('identificationcodetypes_plural')}</PageTitle>
      <PageContent>
        <NewType open={!id && action === ACTIONS.ADD} />
        <EditType open={id && action === ACTIONS.EDIT} />
        <HasRight right={CREATE_RIGHT}>
          <Link to={`/identificationcodetypes/${ACTIONS.ADD}`}>
            <Button btnprimary icon="add" content={t('newIdentificationCodeType')} />
          </Link>
        </HasRight>
        <Table
          infiniteScroll={INFINITE_SCROLL}
          resource={IDENTIFICATIONCODETYPES_RESOURCE}
          url={apiRoutes.identificationCodeTypes()}
          pageSize={50}
          noUserSettings
          filtered
          sorted
        >
          <Actions.Link
            iconbutton
            width="2.5rem"
            icon="eye"
            align="center"
            hasRight={UPDATE_RIGHT}
            url={`/identificationcodetypes/${ACTIONS.EDIT}/:id`}
          />
          <Params.String name="name" width="16rem" minWidth="16rem" grow />
          <Params.String name="tag" width="16rem" minWidth="16rem" grow />
          <Params.Bool name="isHidden" width="16rem" minWidth="16rem" grow noFilter />
          <Menu width="3.5rem" align="center" hasSomeRights={MANAGE_RIGHTS}>
            <Actions.Link
              label="edit"
              icon="edit"
              url={`/identificationcodetypes/${ACTIONS.EDIT}/:id`}
              hasRight={UPDATE_RIGHT}
            />
            <Actions.Delete
              url={apiRoutes.identificationCodeTypes(':id')}
              confirmMessage={t('areYouSureRemoveIdentificationCodeType')}
              hasRight={REMOVE_RIGHT}
            />
          </Menu>
        </Table>
      </PageContent>
    </>
  );
};

IdentificationCodeTypesOverview.propTypes = {};
IdentificationCodeTypesOverview.defaultProps = {};

export default IdentificationCodeTypesOverview;
